import { handleSearch } from '../logic/handleSearch'
import {
  StyleContentWrapper,
  StyleFormItem,
  StyledFilter // StyledSearch
} from './headerBooking.styled'
import { Form } from 'antd'
import { DatePicker } from 'components/atoms'
import { IPeriodTime } from 'interfaces'
import moment from 'moment'
import { FC, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleContainerCard, StyledSearchInput } from 'styles/styledGlobal'
import { debounce, getBeginDate, getEndDate } from 'utils'

interface HeaderPatientProps {
  onSearch?: (val: IPeriodTime) => void
  querySearch?: any
  isPatientPage?: boolean
}

const HeaderPatient: FC<HeaderPatientProps> = ({
  onSearch,
  querySearch,
  isPatientPage
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const clinicId = localStorage.getItem('clinic_id')
  useEffect(() => {
    return () => {
      // form.resetFields()
    }
  }, [querySearch])
  const handleOnSearchDatePicker = () => {
    const { from, to } = form.getFieldsValue()
    const query = {
      from: from ? getBeginDate(from).getTime() : undefined,
      to: to ? getEndDate(to).getTime() : undefined
    }
    if (onSearch) onSearch(query as any)
  }

  const handleOnChangeForm = () => {
    const { from, to } = form.getFieldsValue()
    if (from && to && from.isAfter(to, 'day')) {
      form.setFieldsValue({ to: undefined })
    }
    handleOnSearchDatePicker()
  }
  const handleOnChangeSearch = useCallback(
    debounce(
      (inputSearch: string) =>
        handleSearch(inputSearch, onSearch, {
          ...querySearch,
          clinic_id: Number(clinicId)
        }),
      500
    ),
    [querySearch]
  )
  const disabledStartDate = (current: moment.Moment) => {
    const endDate = form.getFieldValue('to')
    return (
      current &&
      (current > moment().endOf('day') ||
        (endDate && current.isAfter(endDate, 'day')))
    )
  }
  const disabledEndDate = (current: moment.Moment) => {
    const from = form.getFieldValue('from')
    return (
      current &&
      (current > moment().endOf('day') ||
        (from && current.isBefore(from, 'day')))
    )
  }
  return (
    <StyleContainerCard>
      <StyleContentWrapper form={form} onFieldsChange={handleOnChangeForm}>
        <StyledSearchInput
          size="small"
          style={{ height: 40, width: '100%', maxWidth: 250 }}
          placeholder={t('search-by-patient-placeholder')}
          suffix={<img src="/images/ic-search.svg" alt="" />}
          onChange={(e) => handleOnChangeSearch(e?.target?.value)}
        />
        <StyledFilter>
          <StyleFormItem name="from">
            <DatePicker
              title="from-date"
              placeholder="please-select-date"
              disabledDate={disabledStartDate}
              onChange={handleOnChangeForm}
            />
          </StyleFormItem>
          <StyleFormItem name="to">
            <DatePicker
              title="to-date"
              placeholder="please-select-date"
              disabledDate={disabledEndDate}
              onChange={handleOnChangeForm}
            />
          </StyleFormItem>
        </StyledFilter>
      </StyleContentWrapper>
    </StyleContainerCard>
  )
}

export default HeaderPatient
